<template>
  <div class="nodeManage">
    <div class="navMenu">
      <el-button type="primary"  size="small" @click="handleAddNode">添加</el-button>
    </div>
    <div class="nodeTable">

      <el-table
          :data="tableData"
          height="100%">
        <el-table-column prop="nodeHost" label="中间件IP"></el-table-column>
        <el-table-column prop="nodePort" label="中间件端口"></el-table-column>
        <el-table-column prop="nodeType" label="中间件类型">
          <template #default="scope">
            <span v-if="scope.row.nodeType === 1" style="color: green">在线</span>
            <span v-else style="color: red">离线</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template #default="scope">
            <span v-if="scope.row.status" style="color: green">正常</span>
            <span v-else style="color: red">异常</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">

          <template #default="scope">
            <el-button @click="handleEdit(scope.$index, scope.row)" class="option-button" type="text" size="small">修改</el-button>
            <el-button @click="handleDelete(scope.$index, scope.row)" class="option-button" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        v-model="dialogVisible"
        :title="`${dialogType}节点`"
        width="30%">

      <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
      >
        <el-form-item label="中间件IP：" prop="nodeHost">
          <el-input v-model="ruleForm.nodeHost"></el-input>
        </el-form-item>
        <el-form-item label="中间件端口：" prop="nodePort">
          <el-input v-model.number="ruleForm.nodePort"></el-input>
        </el-form-item>
        <el-form-item label="中间件类型：" prop="nodeType">
          <el-radio v-model="ruleForm.nodeType" :label="1">在线</el-radio>
          <el-radio v-model="ruleForm.nodeType" :label="0">离线</el-radio>
        </el-form-item>
      </el-form>


      <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="success" @click="addNote(ruleFormRef)">确定</el-button
        >
      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from 'qs'
import { ElMessageBox, ElMessage } from 'element-plus'
import {ref, onBeforeMount, reactive, computed, watch} from 'vue'
export default {
  name: "NodeManage",
  setup() {
    let tableData = ref([{
      "nodeId": "12700117001",
      "nodeHost": "127.0.0.1",
      "nodePort": 17001,
      "nodeType": 1,
      "linkType": 0,
      "status": true,
    }])

    let dialogVisible = ref(false)
    let dialogType = ref('添加')
    let ruleFormRef = ref()

    const ruleForm = ref({
      nodeHost: '',
      nodePort: null,
      nodeType: 1,
      linkType: 0,
    })
    /**
     * 校验端口号是否符合规范
     */
    const checkPort = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入端口号'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字'))
        } else {
          if (value < 1000) {
            callback(new Error('中间件端口必须大于1000'))
          } else {
            callback()
          }
        }
      }, 200)
    }
    /**
     * 校验IP是否符合规则
     */
    const isValidIp = (rule, value, callback) => {
      var regEx = /,/g
      var ipList = value.toString().replace(regEx, ',').split(',')
      var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
      for (var i in ipList) {
        if (!reg.test(ipList[i])) {
          return callback(new Error('请输入合法的ip地址'))
        } else {
          callback()
        }
      }
      return true
    }
    const rules = reactive({
      nodeHost: [
        {
          required: true, message: '请输入中间件IP', trigger: 'blur'
        },
        {
          validator: isValidIp,
          trigger: 'blur'
        }
      ],
      nodePort: [
        {
          required: true, message: '请输入中间件端口', trigger: 'blur'
        },
        {
          validator: checkPort,
          // message: '中间件端口必须大于1000',
          trigger: 'blur'
        }
      ]
    })

    /**
     * 添加按钮点击
     */
    function handleAddNode() {
      dialogVisible.value = true
      dialogType.value = '添加'
    }
    /**
     * 修改按钮点击
     * @type {handleEdit}
     */
    let handleEdit = ((index, row) => {
      dialogType.value = '修改'
      console.log(index, row.nodeId);
      dialogVisible.value = true
      ruleForm.value = {...row}
      console.log(row)
    })
    //添加节点后，顺便添加设备
    let addEquipByNode =( ()=>{
      let ip = ruleForm.value.nodeHost
      let port = ruleForm.value.nodePort;
      let nodeid = ip.split('.').join('')+port.toString();
      console.log(nodeid);
      axios.get('/api1/nodemanage/updateEquipment/'+nodeid);
    })
    //删除节点后也要删除节点下的设备
    let deletEquipByNode = ((nodeid)=>{
      console.log(nodeid);
      axios.get('/api1/nodemanage/deleteEquipment/'+nodeid);
    })

    /**
     * 保存节点信息
     * @type {addNote}
     */
    let addNote = ((form) => {
      form.validate((valid) => {
        if (valid) {
          console.log('验证通过')
          console.log(form);
          addEquipByNode()
          if(dialogType.value === '添加') {
            axios.put('/api2/node', qs.stringify(ruleForm.value)).then(res => {
              let data = res.data
              if(data.code === 200) {
                //添加中间件，应该添加新的设备
                ElMessage.success(data.message)
                getTableData()
                dialogVisible.value = false
                ruleForm.value = {
                  nodeHost: '',
                  nodePort: null,
                  nodeType: 1,
                  linkType: 0,
                }
              }
              else {
                ElMessage.error(data.message)
              }
            })
          }
          else {
            console.log(ruleForm.value.nodeId)
            axios.delete(`/api2/node/${ruleForm.value.nodeId}` ).then(res => {
              let data = res.data
              if(data.code === 200) {
                axios.put('/api2/node', qs.stringify(ruleForm.value)).then(res => {
                  let data = res.data
                  if(data.code === 200) {
                    ElMessage.success('节点修改成功')
                    getTableData()
                    dialogVisible.value = false
                    ruleForm.value = {
                      nodeHost: '',
                      nodePort: null,
                      nodeType: 1,
                      linkType: 0,
                    }
                  } else {
                    ElMessage.error(data.message)

                  }
                })
              } else {
                ElMessage.error(data.message)
              }
            })
          }
        } else {
          console.log('error submit!')
          return false
        }
      })

    })

    let getTableData = (() => {
      axios.get('/api2/node/info').then(res => {
        if(res.data.code === 200) {
          tableData.value = res.data.data
        }
      })
    })

    /**
     * 删除节点
     * @type {handleDelete}
     */
    let handleDelete = ((index, row) => {
      console.log('删除', row.nodeId);
      deletEquipByNode(row.nodeId);
      axios.delete(`/api2/node/${row.nodeId}` ).then(res => {
        let data = res.data
        if(data.code === 200) {
          ElMessage.success(data.message)
          getTableData()
        } else {
          ElMessage.error(data.message)

        }
      })
    })

    onBeforeMount(() => {
      getTableData();
    })

    return {
      tableData,
      dialogVisible,
      ruleFormRef,
      ruleForm,
      rules,
      dialogType,
      addEquipByNode,
      handleAddNode,
      handleEdit,
      handleDelete,
      deletEquipByNode,
      addNote
    }
  }
}
</script>

<style lang="scss">
.nodeManage{
  display: flex;
  flex-direction: column;
  //width: 100%;
  height: calc(100vh - 50px);
  //overflow: hidden;
  //align-content: center;
  /*margin-bottom: 10px;*/
  background-color: #303749;
  .navMenu {
    height: 52px;
    background-color: #2c3242;
    position: relative;
    margin: 10px;
    .el-button:hover{
      border-color: #42b983;
      color: #42b983;
    }
    .el-button {
      position: absolute;
      background-color: #2C3242;
      border-color: #fff;
      top: 10px;
      left: 20px;

    }
  }
  //.noteTable {
  //  margin-top: 10px;
  //  margin-left: 10px;
  //  margin-right: 10px;
  //  background-color: #2c3242;
  //  height: 750px;
  //}
  .nodeTable {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    background-color: #2c3242;
    height: 75%;
    .option-button:hover {
      color: #359186;
    }
    .option-button {
      color: white;
    }
    //去除表格最下面那条线
    .el-table::before{
      height: 0px;
    }
    .el-table {
      background-color: #2c3242;
      //去除表头下面那条线
      th.el-table__cell.is-leaf{
        border-bottom: 0px;
      }
      //设置排序图标的颜色
      // .descending .sort-caret.descending {
      //   border-top-color: #359186;
      // }
      // .ascending .sort-caret.ascending {
      //   border-bottom-color: #359186;
      // }
      .cell{
        text-align: center;
      }
      th{
        background-color: #2c3242;
        color: #fff;
        // border-right: 1px solid rgba(256, 256, 256, 0.5);
      }
      tr{
        background-color: #2c3242;
        color: #fff;
        td{
          border-bottom: 0px;
        }
      }
      tr:hover td{
        background-color: #2c3242 !important;
      }
    }
  }
  .el-dialog__header {
    background: #2c3242;
    .el-dialog__title {
      color: white;
    }
  }
  .el-dialog__body {
    background: #2c3242;
    .el-form-item__label {
      color: white;
    }
    .el-radio__label {
      color: white;
    }
    .el-input{
      .el-input__inner{
        background-color: #303749;
        color: #fff;
        border: 1px #fff solid;
      }
    }
    .el-input .el-input__inner.active{
      border: 1px red solid;
    }
  }
  .el-dialog__footer {
    background: #2c3242;
    border-top: 1px white solid;
    .el-button--success{
      background: #359186;
      border: 0;
    }

    .el-button--success:hover{
      background: #3a9f93;
    }

  }
}
</style>
